// src/components/SessionHandler.js
import React, { useEffect, useState } from "react";
import { onSessionExpired } from "../utils/sessionEvents";
import SessionExpiredModal from "./SessionExpiredModal";

const SessionHandler = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const unsubscribe = onSessionExpired(() => setVisible(true));
    return unsubscribe;
  }, []);

  const handleOk = () => {
    sessionStorage.clear();
    window.location.href = "/"; // redirect to login
  };

  return (
    <SessionExpiredModal visible={visible} onOk={handleOk} />
  );
};

export default SessionHandler;
